import { APIURL } from "../constant/apiConstant";
import ApiService from "./apiRequest";
import { Encryption as encrypt} from '../utilities/Encryption';

export const createLoan = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.get(APIURL.GET_ENC_KEY).then(async (res) => {
      const encryptedPan = await encrypt(params.documentInfo.docNo, res.data);
      const ecryptedParams = { ...params, documentInfo:{ docType:params.documentInfo.docType, docNo:encryptedPan } }
      ApiService.postwithtoken(APIURL.APPLY_LOAN, ecryptedParams)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  });
};
export const getCustomerInfo = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_CUST_INFO, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const updateLoan = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.UPDATE_LOAN, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getStateList = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_STATE_LIST, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getCityList = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_CITY_LIST, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getEmployerInfo = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_EMPLOYER_INFO, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getAllApplicationIds = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ALL_APPLICATIONS, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getApplicationStatus = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_APPLICATION_STATUS, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getVehicleInfo = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_VEHICLE_BRAND_INFO, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
